import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BookOpen } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ContinueReading = ({ editorId, color, onOpen, visibleIds }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const token = localStorage.getItem('subscriberToken');
    if (!token) return;
    const load = () => axios.get(`${API}/digital/${editorId}/subscriber/history?auth=${token}`)
      .then((r) => setItems((r.data.books || []).filter((b) => !b.finished)))
      .catch(() => setItems([]));
    load();
    const onVis = () => { if (document.visibilityState === 'visible') load(); };
    window.addEventListener('focus', load);
    document.addEventListener('visibilitychange', onVis);
    return () => { window.removeEventListener('focus', load); document.removeEventListener('visibilitychange', onVis); };
  }, [editorId]);
  const shown = items.filter((b) => !visibleIds || visibleIds.has(b.id)).slice(0, 10);
  if (!shown.length) return null;
  return (
    <section data-testid="continue-reading" style={{ background: `color-mix(in srgb, ${color} 12%, white)`, borderTop: `1px solid color-mix(in srgb, ${color} 30%, white)`, padding: '2rem 0 2.25rem' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 2rem' }}>
        <h2 className="text-base md:text-lg" style={{ fontWeight: 700, color: '#2D3748', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: 8 }}>
          <BookOpen className="w-5 h-5" style={{ color }} /> Continue a leitura
        </h2>
        <div className="continue-scroll" data-testid="continue-reading-scroll" style={{ '--cr-color': color, display: 'flex', gap: '1rem', overflowX: 'auto', paddingBottom: '0.75rem', scrollSnapType: 'x mandatory' }}>
          {shown.map((h) => {
            const cover = h.capa_url ? (h.capa_url.startsWith('http') ? h.capa_url : `${process.env.REACT_APP_BACKEND_URL}${h.capa_url}`) : null;
            return (
              <button key={h.id} type="button" onClick={() => onOpen(h.id)} data-testid={`continue-item-${h.id}`}
                style={{ flex: '0 0 130px', scrollSnapAlign: 'start', background: 'white', border: '1px solid #e2e8f0', borderRadius: 10, padding: 0, cursor: 'pointer', textAlign: 'left', overflow: 'hidden', transition: 'transform 0.15s ease, box-shadow 0.15s ease' }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 8px 18px rgba(0,0,0,0.08)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}>
                <div style={{ height: 170, background: `linear-gradient(135deg, ${color}, ${color}99)` }}>
                  {cover && <img src={cover} alt={h.titulo} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
                </div>
                <div style={{ padding: '0.5rem 0.6rem 0.6rem' }}>
                  <p style={{ fontSize: '0.8rem', fontWeight: 600, color: '#2D3748', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{h.titulo}</p>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};
